<template>
    <div>
        <div class="modal-card is-full">
            <header class="modal-card-head">
                <p class="has-text-white has-text-center is-size-1"> User For Item Does Not Exist </p>
            </header>
            <section class="modal-card-body has-background-dvodark">
            <p class="has-text-white has-text-center is-size-3"> Please enter the customer's first and last name. This item will be automatically registered to this user</p>
                <div class="field">
                    <div class="control">
                    <input id="usernameInput" class="input has-text-white" placeholder="First Name" type="text" v-model="firstName">
                    </div>
                </div>
                <div class="field">
                <div class="control">
                    <input id="emailInput" class="input has-text-white"  placeholder="Last Name" type="text" v-model="lastName">
                </div>
                </div>
                <div class="field">
                <div class="control">
                    <input id="passwordInput" class="input has-text-white"  placeholder="Address" type="text" v-model="address">
                </div>
                </div>
                <div class="field">
                <div class="control">
                    <input id="passwordInput" class="input has-text-white"  placeholder="Country" type="text" v-model="country">
                </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                    <div class="field is-grouped">
                        <p class="control">
                                <b-button @click="signUp(); $emit('close'); $emit('onSubmit');" class="button is-dvogreen" expanded>Sign Up</b-button>
                        </p>
                        <p class="control">
                                <b-button @click="$emit('onCancel'); $emit('close')" class="button is-danger" expanded>Cancel Request</b-button>
                        </p>
                    </div>
            </footer>
        </div>   
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { personHandler, itemHandler } from '../graphql/mutations'

export default {
    data() {
        return {
        username: "",
        email: "",
        password: "",
        userSubHolder: null,
        firstName: null,
        lastName: null,
        address: null,
        country: null
        };
    },
    props:['initSerial'],
    methods:{
        async signUp() {
            const personHolder = await API.graphql({
                query: personHandler,
                variables: {
                input: {
                    request_type: 'create',
                    cognito_id: null,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    address: this.address,
                    country: this.country,
                    email: ''
                }}
            });

            const personId = personHolder.data.personHandler.id

            await API.graphql({
                query: itemHandler,
                variables: {
                input: {
                    request_type: 'update_person',
                    person_id: personId,
                    serial: this.initSerial
                }}
            });
        }
    },
}
</script>

<style lang="scss">
</style>